import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { ProductService } from './service/ProductService';

function TestLawyerTable({data}) {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        //ProductService.getProductsMini().then(data => setProducts(data));
    }, []);

    return (
        <>

            <div>
                <h5>Abogados</h5>
            </div>
            
            
        
            <div className="card">
                <DataTable stripedRows value={data} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="name" header="Nombre"></Column>
                    <Column field="lawyer_phone" header="Telefono"></Column>
                    <Column field="logg_express" header="Logged"></Column>
                    <Column field="lawyer_matricula" header="Matricula"></Column>
                </DataTable>
            </div>
        </>
    );
}

export default TestLawyerTable